import useI18n from '@/shared/hooks/usei18n'
import { Badge } from '@/common'

export default function CbamReportingStatusBadge({ status }: { status: string }) {
  const { t } = useI18n()
  if (status === 'PAST_DEADLINE') {
    return (
      <Badge variant="blue">
        {t('cbamReporting:cbamReportingPeriodCard.status.PAST_DEADLINE')}
      </Badge>
    )
  }

  if (status === 'IN_PROGRESS') {
    return (
      <Badge variant="yellow">
        {t('cbamReporting:cbamReportingPeriodCard.status.IN_PROGRESS')}
      </Badge>
    )
  }
  if (status === 'COMPLETED') {
    return (
      <Badge variant="green">{t('cbamReporting:cbamReportingPeriodCard.status.COMPLETED')}</Badge>
    )
  }
}
